import React from 'react';
import { useLocation } from 'react-router-dom';

const WelcomeBanner = () => {

  const location = useLocation();

  return(
    <div className="top--banner">
      {location.pathname.split("/")[1] === "plan" ?
        <p className="welcome--banner">
          WELCOME TO MARQUET!
          <b className="subscribing--message" style={{ fontStyle: 'normal' }}> Thank you for subscribing</b>
        </p>:
        <p className="banner--message">
          Because we know you have to up your game, we’re  making events affordable.
        </p>
      }
    </div>
  )
}

export default WelcomeBanner;